import React, { Component } from 'react';
import _ from 'lodash';
import moment from 'moment';
import { Link } from 'react-router-dom';
import { Pagination } from 'antd';
import queryString from 'query-string';
import { Slider, StepsToGetQuote, WithTitle, TipsTrendsItem, Search, PopularProducts, MainSlider } from '../components';
import { withRedux } from '../hoc';
import { getServiceUrl } from '../utils';

const PAGE_SIZE = 12;
const TIPSTRENDS_ID = _.toInteger(process.env.REACT_APP_TIPSTRENDS_ID);

const PrevArrow = props => {
  const { className, onClick } = props;
  return (
    <div className={className} onClick={onClick}>
      {'< BACK'}
    </div>
  );
};

const NextArrow = props => {
  const { className, onClick } = props;
  return (
    <div className={className} onClick={onClick}>
      {'NEXT >'}
    </div>
  );
};

const mapStateToProps = state => {
  return {
    t: _.get(state, 't'),
    languages: _.get(state, 'languages'),
    post: _.get(state, 'post')
  };
};

const actions = {};

@withRedux(mapStateToProps, actions)
export default class TipsTrends extends Component {
  getData = () => {
    let datas = _.get(this.props, 'post.posts.data');
    datas = _.filter(datas, data => data.post_category_id === TIPSTRENDS_ID);
    datas = _.orderBy(datas, ['created_at', 'updated_at'], ['desc', 'desc']);
    return datas;
  };
  getDataPopular = () => {
    const currentLanguage = _.get(this.props, 'languages.currentActive');
    let datas = this.getData();
    if (_.isEmpty(datas)) return datas;
    datas = _.filter(datas, data => {
      return data.popular[currentLanguage] === true;
    });
    datas = _.orderBy(datas, ['created_at', 'updated_at'], ['desc', 'desc']);
    return datas;
  };
  getCategoryData = () => {
    return _.get(this.props, `post.categories.data.${TIPSTRENDS_ID}`);
  };
  getCurrentPage = () => {
    const { search } = this.props.location;
    const parsed = queryString.parse(search);
    const currentPage = _.toInteger(_.get(parsed, 'page', 1));
    return currentPage;
  };
  handleChangePagination = page => {
    const params = {
      page
    };
    const stringified = queryString.stringify(params);
    this.props.history.push({
      pathname: '/tips-trends',
      search: `?${stringified}`
    });
  };
  renderPagination = () => {
    const currentPage = this.getCurrentPage();
    const tiptrends = this.getData();
    const tiptrendCount = _.size(tiptrends);
    return (
      <Pagination
        current={currentPage}
        defaultPageSize={PAGE_SIZE}
        total={tiptrendCount}
        onChange={this.handleChangePagination}
      />
    );
  };
  getTipTrendsPagination = tiptrends => {
    const currentPage = this.getCurrentPage();
    const paginationTiptrends = _.slice(_.toArray(tiptrends), (currentPage - 1) * PAGE_SIZE, PAGE_SIZE * currentPage);
    return paginationTiptrends;
  };
  render() {
    const { t } = this.props;
    let tiptrends = this.getData();
    tiptrends = this.getTipTrendsPagination(tiptrends);
    const popularTiptrends = this.getDataPopular();
    const categoryData = this.getCategoryData();
    // const thisMonth = _.filter(tiptrends, value => {
    //   return moment(value.created_at).isSame(moment(), "month");
    // });
    // const lastMonth = _.filter(tiptrends, value => {
    //   return moment(value.created_at).isSame(moment().subtract(1, "months"), "month");
    // });
    return (
      <div className="tipstrends-page container-wrapper">
        <div className="search-block">
          <Search.Main />
        </div>
        <div className="banner-block">
          <div
            className="topic"
            dangerouslySetInnerHTML={{
              __html: t({
                en: '- Tips & <span class="text-red">Trends</span> -',
                th: '- เทคนิคและข่าวสาร -'
              })
            }}
          />
          <div className="media-slide">
            <MainSlider data={_.get(categoryData, 'media_image_slide')} />
          </div>
        </div>
        <div className="tips-trends-list">
          {/* <div className="this-month">
            <div className="container">
              <div className="with-title-with-slide">
                <WithTitle title="THIS MONTH" backgroundColor="#d0021b">
                  {_.size(thisMonth) > 0 ? (
                    <Slider
                      className="arrow-type-text"
                      items={thisMonth}
                      uiRenderer={data => {
                        const date = moment(data.created_at).format("MMM D YYYY");
                        return (
                          <Link to={`/tips-trends/detail/${_.get(data, "id")}`}>
                            <TipsTrendsItem.Grid
                              image={_.get(data, "image.full_file_path")}
                              date={date}
                              title={t(_.get(data, "title"))}
                            />
                          </Link>
                        );
                      }}
                      settings={{
                        slidesToShow: 4,
                        slidesToScroll: 1,
                        prevArrow: <PrevArrow />,
                        nextArrow: <NextArrow />
                      }}
                    />
                  ) : (
                    <div className="tips-trends-empty">No Content</div>
                  )}
                </WithTitle>
              </div>
            </div>
          </div> */}
          <div className="popular-tips">
            <div className="container">
              <div className="with-title-with-slide">
                <WithTitle title={t('Popular Tips')} backgroundColor="#d0021b">
                  <Slider
                    className="arrow-type-text"
                    items={popularTiptrends}
                    uiRenderer={item => {
                      const date = moment(item.created_at).format('MMM D YYYY');
                      const full_file_path = `${getServiceUrl()}/${_.get(item, 'image.path')}`;
                      return (
                        <Link to={`/tips-trends/detail/${_.get(item, 'id')}`}>
                          <TipsTrendsItem.Grid image={full_file_path} date={date} title={t(_.get(item, 'title'))} />
                        </Link>
                      );
                    }}
                    settings={{
                      slidesToShow: 4,
                      slidesToScroll: 1,
                      prevArrow: <PrevArrow />,
                      nextArrow: <NextArrow />
                    }}
                  />
                </WithTitle>
              </div>
            </div>
          </div>
          {/* <div className="last-month">
            <div className="container">
              <div className="with-title-with-slide">
                <WithTitle title="LAST MONTH" backgroundColor="#d0021b">
                  {_.size(lastMonth) > 0 ? (
                    <Slider
                      className="arrow-type-text"
                      items={lastMonth}
                      uiRenderer={item => {
                        const date = moment(item.created_at).format("MMM D YYYY");
                        return (
                          <Link to={`/tips-trends/detail/${_.get(item, "id")}`}>
                            <TipsTrendsItem.Grid
                              image={_.get(item, "image.full_file_path")}
                              date={date}
                              title={t(_.get(item, "title"))}
                            />
                          </Link>
                        );
                      }}
                      settings={{
                        slidesToShow: 4,
                        slidesToScroll: 1,
                        prevArrow: <PrevArrow />,
                        nextArrow: <NextArrow />
                      }}
                    />
                  ) : (
                    <div className="tips-trends-empty">No Content</div>
                  )}
                </WithTitle>
              </div>
            </div>
          </div> */}
          <div className="all-tips">
            <div className="container">
              <div className="with-title-with-slide">
                <WithTitle title={t('All Tips')} backgroundColor="#d0021b">
                  <div className="tips-list">
                    <div className="row">
                      {_.map(tiptrends, (item, key) => {
                        const date = moment(item.created_at).format('MMM D YYYY');
                        const full_file_path = `${getServiceUrl()}/${_.get(item, 'image.path')}`;
                        return (
                          <div key={key} className="col-md-3">
                            <Link to={`/tips-trends/detail/${_.get(item, 'id')}`}>
                              <TipsTrendsItem.Grid image={full_file_path} date={date} title={t(_.get(item, 'title'))} />
                            </Link>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                  <div className="pagination-block">{this.renderPagination()}</div>
                  {/* {_.size(tiptrends) <= 12 ? (
                    <div className="row">
                      {_.map(tiptrends, (item, key) => {
                        const date = moment(item.created_at).format("MMM D YYYY");
                        return (
                          <div key={key} className="col-md-3">
                            <Link to={`/tips-trends/detail/${_.get(item, "id")}`}>
                              <TipsTrendsItem.Grid
                                image={_.get(item, "image.full_file_path")}
                                date={date}
                                title={t(_.get(item, "title"))}
                              />
                            </Link>
                          </div>
                        );
                      })}
                    </div>
                  ) : (
                    <Slider
                      className="arrow-type-text"
                      items={tiptrends}
                      uiRenderer={item => {
                        const date = moment(item.created_at).format("MMM D YYYY");
                        return (
                          <Link to={`/tips-trends/detail/${_.get(item, "id")}`}>
                            <TipsTrendsItem.Grid
                              image={_.get(item, "image.full_file_path")}
                              date={date}
                              title={t(_.get(item, "title"))}
                            />
                          </Link>
                        );
                      }}
                      settings={{
                        rows: 3,
                        slidesToShow: 4,
                        slidesToScroll: 1,
                        prevArrow: <PrevArrow />,
                        nextArrow: <NextArrow />
                      }}
                    />
                  )} */}
                </WithTitle>
              </div>
            </div>
          </div>
        </div>
        <div className="popular-products-block">
          <div className="container">
            <PopularProducts />
          </div>
        </div>
        <div className="steps-quote-block">
          <StepsToGetQuote />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/TipsTrends.js